<ion-header translucent [ngClass]="isHomeSignagure ? 'display-none' : 'recovery-header'" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button color="primary" defaultHref="/"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-no-padding" [ngClass]="isHomeSignagure ? 'login-background' : ''">
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-no-padding ion-align-items-center ion-justify-content-center">
      <ion-col sizeLg="6" sizeMd="6" sizeXl="6" sizeSm="12" class="ion-no-padding ion-text-center">
        <div class="logo">
          <ion-img margin-auto [src]="logo" [ngClass]="isHomeSignagure ? 'login-logo' : 'recovery-logo'">
          </ion-img>
        </div>
      </ion-col>
      <ion-col sizeLg="6" sizeMd="6" sizeXl="6" sizeXs="12" sizeSm="12" class="col-form">
        <ion-router-outlet></ion-router-outlet>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
